import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverRating extends Layout {
    dataheaderDriverRating: DataHeader;
    panelDriverRating: Panel;
    sourceDriverRating: DataSource;
    switchIsActive: Switch;
    textboxDescription: Textbox;
    textboxDriverRating: Textbox;
}
